import React, { useEffect } from "react";
import "./App.scss";
import "pages/Screensaver";
import { Route, Routes, useLocation } from "react-router-dom";

import Screensaver from "pages/Screensaver";
import Home from "pages/Home";
import Detail from "pages/Detail";
import Menu from "pages/Menu";
import Video from "pages/Video";
import Signature from "pages/Signature";
import Loader from "components/Loader";
import { useNavigation } from "./hooks/useNavigation";

function App() {
  const location = useLocation();

  const navigate = useNavigation();

  const screensaverTime = 90000;

  let screensaverTimeout: NodeJS.Timeout;

  const clearTM = () => {
    screensaverTimeout && clearTimeout(screensaverTimeout);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const timeoutSet = () => {
    clearTM();

    screensaverTimeout = setTimeout(() => {
      location.pathname !== "/" && navigate("/");
    }, screensaverTime);
  };

  useEffect(() => {
    timeoutSet();

    window.addEventListener("mousemove", () => {
      timeoutSet();
    });

    window.addEventListener("touchend", () => {
      timeoutSet();
    });
  }, [timeoutSet]);

  return (
    <>
      <Loader />
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Screensaver />} />
        <Route path="/home" element={<Home />} />
        <Route path="/video" element={<Video />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/detail/:id" element={<Detail />} />
        <Route path="/signature" element={<Signature />} />
      </Routes>
    </>
  );
}

export default App;
